import { PROFILE_ENDPOINTS } from '../constants';
import { API_ENDPOINTS } from '../../Auth/constants';
import { ApiClient } from '@utils/apiClient';
import {
  UserProfile,
  NotificationPreferences,
  ProfileUpdateData,
  PasswordChangeData,
} from '../types';

export const profileService = {
  async getCurrentUser(): Promise<UserProfile> {
    const response = await ApiClient.get(PROFILE_ENDPOINTS.CURRENT_USER);

    return response.json();
  },

  async updateUserProfile(data: ProfileUpdateData): Promise<UserProfile> {
    const response = await ApiClient.patch(PROFILE_ENDPOINTS.CURRENT_USER, data);

    return response.json();
  },

  async updateUserPhoto(file: File): Promise<{ photo: string }> {
    if (!file) {
      throw new Error('No file provided');
    }

    const formData = new FormData();
    formData.append('file', file);

    const response = await ApiClient.postFormData(PROFILE_ENDPOINTS.UPDATE_PHOTO, formData);

    if (!response.ok) {
      throw new Error('Failed to update photo');
    }

    return response.json();
  },
  async getNotificationPreferences(): Promise<NotificationPreferences> {
    const response = await ApiClient.get(PROFILE_ENDPOINTS.NOTIFICATION_PREFERENCES);

    return response.json();
  },

  async updateNotificationPreferences(
    data: NotificationPreferences
  ): Promise<NotificationPreferences> {
    const response = await ApiClient.patch(PROFILE_ENDPOINTS.NOTIFICATION_PREFERENCES, data);

    return response.json();
  },
  async changePassword(data: PasswordChangeData): Promise<void> {
    const response = await ApiClient.post(API_ENDPOINTS.CHANGE_PASSWORD, data);

    if (!response.ok) {
      throw new Error('Failed to change password');
    }
  },
};
